import { render, staticRenderFns } from "./CrewBlakclist.vue?vue&type=template&id=9be8ba90"
import script from "./CrewBlakclist.vue?vue&type=script&lang=js"
export * from "./CrewBlakclist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports